// Imports
import React from 'react';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components/macro';
import Tippy from '@tippyjs/react';
import tippyProps from '../../../../../shareables/foundation/front-end/utils/tippy-props';


// Styled component
export const Wrapper = styled.div`
	display: flex;
	
	> span {
		margin-top: auto;
		margin-bottom: auto;
		
		> svg {
			margin-right: 0.5rem;
			color: rgb(170, 170, 170);
		}
	}
	
	&:not(:last-child) {
		border-bottom: 1px solid #eee;
		padding-bottom: 0.3rem;
		margin-bottom: 0.3rem;
	}
`;


// Define the accepted props
interface Props {
	icon: IconDefinition;
	text: string | JSX.Element;
	tooltip?: string;
}


// Function component
const DetailItem: React.FC<Props> = ({ icon, text, tooltip }) => {
	// Prevent some problematic usages
	if (icon.prefix !== 'far' && icon.prefix !== 'fab') {
		throw new Error('A detail’s icon should come from the "regular" or "brand" package');
	}
	
	
	// Build  icon JSX
	let iconJSX = (
		<span>
			<FontAwesomeIcon icon={icon} fixedWidth />
		</span>
	);
	
	if (tooltip) {
		iconJSX = (
			<Tippy {...tippyProps} content={tooltip}>
				{iconJSX}
			</Tippy>
		);
	}
	
	
	// Return JSX
	return (
		<Wrapper>
			{iconJSX}
			
			<div>{text}</div>
		</Wrapper>
	);
};

export default DetailItem;
